export const OPENS_IN_NEW_WINDOW = "opens in a new window"

export const opensInNewWindowLabel = (label) => `${label} (${OPENS_IN_NEW_WINDOW})`

export const requiredFieldLabel = (label, isRequired) => {
	if (!isRequired) {
		return label
	}
	return `${label} (required)`
}
